import { Station } from 'src/screens/Main/components/AddLineForm/types';
import { AddressInfo } from './types';

export const asAddressInfo = (stationInput: Station): AddressInfo => ({
    city: stationInput.city || '',
    street: stationInput.street,
    houseNum: String(stationInput.houseNum),
});
